import { render, staticRenderFns } from "./CartTableCustomOrderItem.vue?vue&type=template&id=167f463c"
import script from "./CartTableCustomOrderItem.vue?vue&type=script&lang=js"
export * from "./CartTableCustomOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports